import BaseModel from './BaseModel';

export default class Menu extends BaseModel {

}
